import { VariantFinishEnum } from "@sorcery/db";

import { SetSymbol } from "@sorcery/ui/src/components/molecules/SetSymbol";
import { getVariantSnippet, getVariantTitle } from "@sorcery/utils/universal/variant";
import type { VariantType } from "~/types/card";

export const VariantLabel = ({
  variant,
  color = "white",
  size = "lg",
}: {
  variant: VariantType;
  color?: "black" | "white";
  size?: "sm" | "lg";
}) => {
  return (
    <div className="flex items-center whitespace-nowrap">
      <span className="-mt-0.5">
        <SetSymbol set={variant.setCard.set.code} product={variant.product} color={color} />
      </span>
      <span
        className={`relative select-none ${
          variant.finish === VariantFinishEnum.Foil && "underline-sparkle"
        }`}
      >
        {size === "sm" ? getVariantSnippet(variant) : getVariantTitle(variant)}
      </span>
    </div>
  );
};
